export default "__VITE_ASSET__38818b0e__"